import { PhoneNumber } from "../misc/PhoneNumber";
import { Link } from "react-router";
import { RemoveEmployeesButton } from "./RemoveEmployeesButton";
import { CanAccess, InfiniteListBase, useListContext } from "ra-core";
import { Button } from "@/components/ui/button";
import MobileHeader from "../layout/MobileHeader";
import { MobileContent } from "../layout/MobileContent";
import { MobileListSearch } from "../layout/MobileListSearch";
import { InfinitePagination } from "../misc/InfinitePagination";
import { getSalesRoleLabel, effectiveRole } from "./roles";
import type { Sale } from "../types";

export function SalesListMobile() {
  return (
    <CanAccess resource="sales" action="list">
      <InfiniteListBase
        perPage={25}
        sort={{ field: "first_name", order: "ASC" }}
      >
        <UserCards />
      </InfiniteListBase>
    </CanAccess>
  );
}

function UserCards() {
  const {
    data = [],
    isPending,
    error,
    refetch,
    selectedIds,
    onToggleItem,
  } = useListContext<Sale>();
  return (
    <>
      <MobileHeader
        title="Пользователи"
        actions={
          <CanAccess resource="sales" action="create">
            <Button asChild size="sm">
              <Link to="/sales/create">Добавить</Link>
            </Button>
          </CanAccess>
        }
      />
      <MobileContent>
        <MobileListSearch label="Поиск пользователей" />
        {selectedIds.length > 0 && <RemoveEmployeesButton />}
        {error ? (
          <div role="alert" className="rounded-xl border bg-card p-4">
            Не удалось загрузить пользователей.
            <Button variant="outline" onClick={() => refetch()}>
              Повторить
            </Button>
          </div>
        ) : (
          <div className="space-y-3" aria-busy={isPending}>
            {data.map((user) => (
              <article key={user.id} className="rounded-xl border bg-card p-4">
                <label className="flex items-center gap-2 mb-3">
                  <input
                    type="checkbox"
                    className="size-5"
                    checked={selectedIds.includes(user.id)}
                    onChange={() => onToggleItem(user.id)}
                  />
                  Выбрать пользователя
                </label>
                <Button asChild variant="outline" className="mb-3">
                  <Link to={`/sales/${user.id}`}>Редактировать</Link>
                </Button>
                <h2 className="break-words font-semibold">
                  {[user.first_name, user.last_name].filter(Boolean).join(" ")}
                </h2>
                <p className="break-all text-sm text-muted-foreground">
                  {user.email}
                </p>
                <PhoneNumber value={user.phone} />
                <p className="mt-2 text-sm">
                  {getSalesRoleLabel(effectiveRole(user))}
                </p>
                {user.hidden_from_team && (
                  <p className="text-sm">Скрыт от команды</p>
                )}
                <p className="text-sm text-muted-foreground">
                  {user.disabled ? "Отключён" : "Активен"}
                </p>
              </article>
            ))}
            {!isPending && !data.length && (
              <p className="p-4">Пользователи не найдены</p>
            )}
            {isPending && !data.length && (
              <p className="p-4">Загрузка пользователей…</p>
            )}
          </div>
        )}
        <InfinitePagination />
      </MobileContent>
    </>
  );
}
